module.exports = __webpack_public_path__ + "img/target-5.1d9e4017.png";